import { render, staticRenderFns } from "./Memo.vue?vue&type=template&id=90015b5a&scoped=true&"
import script from "./Memo.vue?vue&type=script&lang=js&"
export * from "./Memo.vue?vue&type=script&lang=js&"
import style0 from "./Memo.vue?vue&type=style&index=0&id=90015b5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90015b5a",
  null
  
)

export default component.exports